import { Component, Prop, Vue } from 'vue-property-decorator';
import RadioGroup from '@/components/forms/RadioGroup.vue';
@Component({
    name: 'BooleanRadios',
    components: { RadioGroup },
})
export default class default_1 extends Vue {
    @Prop()
    label;
    // Initial value property.
    @Prop({ default: null })
    value;
    @Prop({ default: 'Yes' })
    yesLabel;
    @Prop({ default: 'No' })
    noLabel;
    @Prop({ default: null })
    optional;
    @Prop({ default: false })
    hideAsterisk;
    options = null;
    internal = null;
    created() {
        this.internal = this.value;
        this.options = [
            { label: this.yesLabel, value: true },
            { label: this.noLabel, value: false },
        ];
    }
}
